import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 26 26" {...props}>
    <polygon points="16.95 19 12.12 14.17 7.3 19 5.12 16.83 9.95 12 5.12 7.17 7.3 5 12.12 9.83 16.95 5 19.12 7.17 14.3 12 19.12 16.83 16.95 19" />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Close.jsx